(() => {
  if (window.sikReaderReviewsReady) return;
  window.sikReaderReviewsReady = true;
  let opener;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sik-reviews-open]');
    const dialog = document.querySelector('[data-sik-reviews-dialog]');
    if (trigger && dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      opener = trigger;
      dialog.showModal();
    }
    if (dialog?.open && (event.target.closest('[data-sik-reviews-close]') || event.target === dialog)) dialog.close();
  }, true);
  const bind = () => {
    document.querySelectorAll('[data-sik-reviews-dialog]').forEach((dialog) => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', bind);
})();
